import { forwardRef, type Ref, type SVGProps } from "react";

function SvgGoldDiamondCloud(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={102}
      height={101}
      fill="none"
      {...props}
    >
      <path
        fill="url(#GoldDiamondCloud_svg__a)"
        stroke="#E6B423"
        strokeWidth={4}
        d="M39.106 6.876c6.571-6.501 17.217-6.501 23.788 0l1.112 1.1a12.9 12.9 0 0 0 9.08 3.72h.283c9.275 0 16.831 7.444 16.831 16.672v.281c0 3.354 1.346 6.575 3.75 8.953l1.112 1.101a16.563 16.563 0 0 1 0 23.594l-1.112 1.1a12.6 12.6 0 0 0-3.75 8.954v.28c0 9.229-7.556 16.674-16.83 16.674h-.284c-3.41 0-6.676 1.34-9.08 3.718l-1.112 1.101c-6.571 6.501-17.217 6.501-23.788 0l-1.112-1.1a12.9 12.9 0 0 0-9.08-3.72h-.283c-9.275 0-16.831-7.444-16.831-16.672v-.281c0-3.354-1.347-6.575-3.75-8.953l-1.113-1.101a16.56 16.56 0 0 1 0-23.594l1.113-1.1a12.6 12.6 0 0 0 3.75-8.954v-.28c0-9.229 7.556-16.674 16.83-16.674h.284c3.41 0 6.676-1.34 9.08-3.718z"
      />
      <path
        fill="url(#GoldDiamondCloud_svg__b)"
        d="m28.276 39.877 21.038-11.572a2.46 2.46 0 0 1 2.372 0l21.039 11.572a2.46 2.46 0 0 1 .84 3.554l-21.04 30.506a2.46 2.46 0 0 1-4.05 0l-21.04-30.505a2.46 2.46 0 0 1 .84-3.554Z"
      />
      <defs>
        <linearGradient
          id="GoldDiamondCloud_svg__a"
          x1={29.85}
          x2={50.574}
          y1={4}
          y2={97.095}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFFBD6" />
          <stop offset={1} stopColor="#FFE191" />
        </linearGradient>
        <linearGradient
          id="GoldDiamondCloud_svg__b"
          x1={34.833}
          x2={50.5}
          y1={33.875}
          y2={75}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A3711D" />
          <stop offset={1} stopColor="#F7C649" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgGoldDiamondCloud);
export default ForwardRef;
